import React, { Component } from "react";
import "./upload.css";
import "./calendar.css";
import { Col, Container, Row } from 'bootstrap-4-react';
import { withRouter, } from "react-router-dom";
import Select from 'react-select'
import moment from 'moment'
import axios from 'axios';

import { Calendar, momentLocalizer } from 'react-big-calendar'
const localizer = momentLocalizer(moment)



const customStyles = {
  control: styles => ({ ...styles, backgroundColor: '#fff', height: 42, width: '90%', margin: '0 auto', marginBottom: 20, }),
}

class RegistrosGastosPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      arraySucursales: [],
      arrayFilesUpload: [],
      id_sucursal: {},
      uploadSteps: { step: 0, text: '', },
      date: this.getDateGeneric(0),
      myEventsList: [],
    }
  }

  getDateGeneric(opt) {
    if(opt === 0)
      return (new Date())
    else {
      let d = new Date()
      d.setMonth(6)
      return new Date(d)
    }

  }

  componentDidMount() {
    //Petition wuuuu
    this.getProgreso()
  }

  getProgreso() {

    const data = {
      user: 'admin',
      date: this.state.date,
    }
    fetch("https://diana.wsoft.com.mx/pos/multiservicios/REST/controllers/controllerWebApp.php?opt=appGetHistoryReports", {
      method: "POST",
      mode: "cors",
      body: JSON.stringify({ ...data, }),
    })
    .then(response => response.json())
    .then((response) => {
      let { arraySucursales, } = response
      let newArr = [], myEventsList = []

      for(let a in arraySucursales) {
        if(arraySucursales[a].id_sucursal !== '0') {
          //registramos en el arr sucursales
          newArr.push(arraySucursales[a])

          //Generamos el array badge indicador de reporte días
          for(let b in arraySucursales[a].day) {
            myEventsList.push({
              id: b,
              title: `${arraySucursales[a].nombre} $${this.number_format(arraySucursales[a].day[b].sum,2)}`,
              allDay: true,
              start: new Date(arraySucursales[a].year, arraySucursales[a].month - 1, arraySucursales[a].day[b].day),
              end: new Date(arraySucursales[a].year, arraySucursales[a].month - 1, arraySucursales[a].day[b].day),
            })
          }

        }

        if(a == ( arraySucursales.length - 1 )) {
          this.setState({
            arraySucursales: newArr,
            myEventsList,
          })
        }
      }
    }).catch((error) => console.log(error));
  }

  onFileChange(file) {
    let { arrayFilesUpload } = this.state

    for(var a in file.target.files) {
      if(typeof file.target.files[a] === 'object') {
        arrayFilesUpload.push(file.target.files[a])
      }

      if(a === (file.target.files.length - 1)) {
        this.setState({ arrayFilesUpload, })
      }
    }
  }

  onFileChangeRemove(indexFile) {
    let { arrayFilesUpload } = this.state

    let newArr = []
    for(var a in arrayFilesUpload) {
      if(a !== indexFile) {
        newArr.push(arrayFilesUpload[a])
      }

      if(a === (arrayFilesUpload.length - 1)) {
        arrayFilesUpload = newArr
        this.setState({ arrayFilesUpload, })
      }
    }
  }

  onUploadFiles() {
    const { arrayFilesUpload, id_sucursal } = this.state

    if(id_sucursal.id_sucursal === '' || id_sucursal.id_sucursal === '0' || !id_sucursal.id_sucursal) {
      alert('Por favor, elige una sucursal válida.')
      return false
    }

    this.setState({ uploadSteps: {step: 1, text: 'Preparando archivos...'} })

    //Si todo sale bien empezamos a subir ficheros por array
    let formData = new FormData();
    arrayFilesUpload.map((t,e) => {
      //Se reinicializa por cada iteración del array upload
      formData.append('files[]', t)
    })
    
    //Después de que termina la iteración de files subimos al servidor
    this.setState({ uploadSteps: {step: 1, text: 'Subiendo...'} })
    axios.post(`https://diana.wsoft.com.mx/pos/multiservicios/REST/controllers/controllerWebApp?opt=setUploadTXT&id_sucursal=${id_sucursal.id_sucursal}`, formData, {})
    .then(res => {
      this.setState({ uploadSteps: {step: 0, text: ''} })
      alert( 'Migración realizada con éxito.' )
      this.setState({arrayFilesUpload: [], })
    })

  }

  render() {
    const { arraySucursales, arrayFilesUpload, uploadSteps, myEventsList } = this.state
    
    return (
      <Container className="initialPage__wrapper"  style={{ backgroundColor: 'transparent', }}>
        {/* Principal Container */}
        <>
          <p className="uploadReports__title">Actualizar reporte de ventas</p>
          <div className="initialPage__principalContainer" style={{ backgroundColor: 'transparent', margin: 0, }}>
            {
              arraySucursales.length > 0 ?
                <Select
                  placeholder="Dirección"
                  // defaultInputValue="Dirección"
                  options={this.state.arraySucursales}
                  onChange={(val) => {this.setState({id_sucursal: val}) }}
                  styles={customStyles} />
              : null
            }

            <div>
              <Calendar
                localizer={localizer}
                events={myEventsList}
                /*views={'month'}*/
                startAccessor="start"
                endAccessor="end"
                style={{ height: 500, width: '100%', marginTop: 200 }}
                onNavigate={(date) => {
                  //Compare if change months
                  if(moment(date).format('MM') !== moment(this.state.date).format('MM')) {
                    this.setState({date}, this.getProgreso);
                  }
                }}
                messages={{
                  next: "Sig",
                  previous: "Ant",
                  today: "Hoy",
                  month: "Mes",
                  week: "Semana",
                  day: "Día"
                }}
              />
            </div>

            {/* Make input to upload */}
            <form className="uploadReports__form" onSubmit={this.onSubmit} style={{ marginTop: 20, clear: 'both', }}>

              <div key={`div_upload_0`}>
                <p>{ arrayFilesUpload.length > 0 ? (<b>({arrayFilesUpload.length} {arrayFilesUpload.length === 1 ? 'archivo' : 'archivos'})</b>): null }</p>
                <p style={{ fontSize: '.7rem', fontStyle: 'italic', }}>Puedes subir más de un TXT</p>
                <label className="form-group" htmlFor={`upload-file-0`}>
                  <p htmlFor={`upload-file-0`} style={{ fontSize: '1rem', color: '#111', cursor: 'pointer', }}>Haz click aquí para subir un archivo</p>
                  <input style={{ display: 'none' }} id={`upload-file-0`} type="file" onChange={(file) => this.onFileChange(file)} multiple />
                </label>
              </div>

              {
                arrayFilesUpload.map((t0,e0) => (
                  <Container key={`files_img_${e0}`}>
                    <Row>
                      <Col style={{ width: '70%' }} xs={3}>
                        <p style={{ width: '100%', whiteSpace: 'nowrap',textOverflow: 'ellipsis',overflow: 'hidden', }}>{t0.name}</p>
                      </Col>
                      <Col style={{ width: '30%' }} >
                        <p style={{ cursor: 'pointer', textAlign: 'right', }} onClick={() => { this.onFileChangeRemove(e0) }}>Remover</p>
                      </Col>
                    </Row>
                  </Container>
                ))
              }

            </form>


            {
              arrayFilesUpload.length > 0 && uploadSteps.step === 0 ? (
                <p className="type__legal" onClick={ () => { this.onUploadFiles() }}>Subir reportes</p>
              ) : null
            }

            {
              arrayFilesUpload.length > 0 && uploadSteps.step === 1 ? (
                <p>{uploadSteps.text}</p>
              ) : null
            }

          </div>
        </>

      </Container>
    );
  }

  initsetState(param) {
    this.props.initsetState(param)
    return true
  }

  uniqid() {
    var pr = '', en = false, result;this.seed = function (s, w) {s = parseInt(s, 10).toString(16);return w < s.length ? s.slice(s.length - w) : (w > s.length) ? new Array(1 + (w - s.length)).join('0') + s : s;};result = pr + this.seed(parseInt(new Date().getTime() / 1000, 10), 8) + this.seed(Math.floor(Math.random() * 0x75bcd15) + 1, 5);if (en) {result += (Math.random() * 10).toFixed(8).toString();} return result;
  }

  number_format(number, decimals, decPoint, thousandsSep) {
    number = (number+'').replace(/[^0-9+\-Ee.]/g, '')
    var n = !isFinite(+number) ? 0 : +number
    var prec = !isFinite(+decimals) ? 0 : Math.abs(decimals)
    var sep = (typeof thousandsSep === 'undefined') ? ',' : thousandsSep
    var dec = (typeof decPoint === 'undefined') ? '.' : decPoint
    var s = ''
    var toFixedFix = function (n, prec) {
      var k = Math.pow(10, prec)
      return ''+(Math.round(n * k) / k)
      .toFixed(prec)
    }
    s = (prec ? toFixedFix(n, prec) : ''+Math.round(n)).split('.')
    if (s[0].length > 3) {
      s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep)
    }
    if ((s[1] || '').length < prec) {
      s[1] = s[1] || ''
      s[1] += new Array(prec - s[1].length+1).join('0')
    }
    return s.join(dec)
  }

};

export default withRouter(RegistrosGastosPage)